import {
    FETCH_USER_DETAILS,
    FETCH_USER_DETAILS_FAIL,
    FETCH_USER_DETAILS_SUCCESS
} from './actionTypes';

const initialState = {
    data: {},
    error: null,
    loading: false,
    loaded: false
};

export function userDetailsReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_USER_DETAILS:
            return {
                ...initialState,
                loading: true
            };
        case FETCH_USER_DETAILS_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loaded: true,
                loading: false
            };
        case FETCH_USER_DETAILS_FAIL: {
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        }
        default:
            return state;
    }
}
